import axios from './axios';

export const getStatistics = payload => axios.post('/info/feeds/news/statistics', { ...payload });

export const getCategories = () => axios.get('/info/feeds/news/statistics/categories');
